import { render, staticRenderFns } from "./publicItem.vue?vue&type=template&id=c535e58c&scoped=true&"
import script from "./publicItem.vue?vue&type=script&lang=js&"
export * from "./publicItem.vue?vue&type=script&lang=js&"
import style0 from "./publicItem.vue?vue&type=style&index=0&id=c535e58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c535e58c",
  null
  
)

export default component.exports